import axios from 'axios';

// Use localhost for local dev, otherwise use the server origin
const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
export const serverEndpoint = isLocal ? 'http://localhost:5000/api/' : `${window.location.origin}/api/`;

const API = axios.create({
  baseURL: serverEndpoint
});

export default API;
